module.exports = __webpack_public_path__ + "static/img/2021.7a58b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2021.png
// module id = IC75
// module chunks = 0